import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import IconLibrary from "./icon-library.js";

const Wrapper = styled.div`
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  width: 100%;
  display: flex;
  flex-direction: column;
  a {
    color: ${({ $linkColor }) => $linkColor};
  }
`;
const Question = styled.div`
  cursor: pointer;
  align-items: center;
`;
const Text = styled.div`
  padding: 1rem 1.5rem;
  padding-left: 1.2rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $textColor }) => $textColor};
`;
const CloseIcon = styled(FontAwesomeIcon)`
  color: ${({ $textColor }) => $textColor};
  margin-right: 1rem;
`;
const Answer = styled.div`
  display: flex;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $textColor }) => $textColor};
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  visibility: hidden;
  transition: all 0.2s ease-in;

  &.visible {
    opacity: 1;
    max-height: 100%;
    visibility: visible;
  }
  span {
    padding: 1.5rem 3.5rem;
  }
`;

export default function Accordion({
  question,
  answer,
  backgroundColor,
  textColor,
  letterSpacing,
  rowSpacing,
  linkColor,
}) {
  const [isOpen, setOpen] = React.useState(false);

  const toggleAnswer = () => {
    setOpen(!isOpen);
  };

  return (
    <Wrapper
      $letterSpacing={letterSpacing}
      $rowSpacing={rowSpacing}
      $linkColor={linkColor}
    >
      <IconLibrary />
      <Question
        itemScope
        itemProp="mainEntity"
        itemType="https://schema.org/Question"
        onClick={toggleAnswer}
      >
        <Text $backgroundColor={backgroundColor} $textColor={textColor}>
          <CloseIcon
            icon={isOpen ? faMinus : faPlus}
            size="1x"
            $textColor={textColor}
          />{" "}
          <span itemProp="name">{question}</span>
        </Text>
        <Answer
          itemScope
          itemProp="acceptedAnswer"
          itemType="https://schema.org/Answer"
          className={isOpen ? "visible" : ""}
          $backgroundColor={backgroundColor}
          $textColor={textColor}
        >
          <span
            itemProp="text"
            dangerouslySetInnerHTML={{ __html: answer }}
          ></span>
        </Answer>
      </Question>
    </Wrapper>
  );
}

Accordion.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  letterSpacing: PropTypes.string,
  rowSpacing: PropTypes.string,
  linkColor: PropTypes.string,
};

Accordion.defaultProps = {
  question: undefined,
  answer: undefined,
};
